import React from 'react'

const STATS = [
  { label: 'Active clients', val: '104', sub: '4 new this month', color: '#3B6D11' },
  { label: 'Hours saved', val: '147h', sub: '23% vs last month', color: '#C9973A' },
  { label: 'Urgent deadlines', val: '3', sub: 'Within 7 days', color: '#E24B4A' },
  { label: 'WhatsApp queue', val: '6', sub: 'Awaiting approval', color: '#185FA5' },
]

const DEADLINES = [
  { name: 'Adeyemi Catering Ltd', filing: 'VAT Return Q1 2025', days: 3, color: '#E24B4A' },
  { name: 'FW Catering Ltd', filing: 'Confirmation Statement', days: 9, color: '#E24B4A' },
  { name: 'Tunde Adesanya', filing: 'VAT Return Q1 2025', days: 14, color: '#C9973A' },
  { name: 'Chioma Nwosu', filing: 'RTI Payroll — April', days: 24, color: '#C9973A' },
  { name: 'JO Tech Solutions Ltd', filing: 'Conf. Statement', days: 83, color: '#3B6D11' },
]

const MODULES = [
  { label: 'Bank Stmt → P&L', path: '/bank-pl', icon: '⬡', desc: 'AI categorises every transaction', live: true },
  { label: 'Deadline Tracker', path: '/deadlines', icon: '◈', desc: '3 urgent, RAG status all clients', live: false },
  { label: 'WhatsApp Engine', path: '/whatsapp', icon: '◉', desc: '6 messages queued for approval', live: false },
  { label: 'VAT Return', path: '/vat', icon: '◧', desc: '3 clients due this quarter', live: false },
  { label: 'CT600 Corp Tax', path: '/ct600', icon: '◨', desc: 'Auto-fills from P&L accounts', live: false },
  { label: 'RTI Payroll', path: '/payroll', icon: '◪', desc: 'PAYE + NI + payslips', live: false },
  { label: 'Self Assessment', path: '/self-assessment', icon: '◫', desc: 'All 4 client types', live: false },
  { label: 'Annual Accounts', path: '/annual-accounts', icon: '◬', desc: 'CH micro-accounts format', live: false },
  { label: 'Conf. Statement', path: '/confirmation', icon: '◭', desc: 'Directors, PSCs, shares', live: false },
  { label: 'Company Formation', path: '/formation', icon: '◮', desc: '6-step CH registration wizard', live: false },
  { label: 'Document Vault', path: '/vault', icon: '▣', desc: 'GDPR compliant file storage', live: false },
]

export default function Dashboard() {
  return (
    <div style={{ padding: 20, maxWidth: 1100 }}>

      {/* AI bar */}
      <div style={{ background: '#0B1929', borderRadius: 12, padding: '11px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, border: '1px solid rgba(201,151,58,0.2)' }}>
        <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#3B6D11', flexShrink: 0 }} />
        <input style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: 'rgba(255,255,255,0.55)', fontSize: 13, fontFamily: 'inherit' }} placeholder="Ask the AI: Process bank statement · Who has VAT due this month? · Draft CT600 for JO Tech..." />
        <button style={{ background: 'rgba(201,151,58,0.1)', border: '1px solid rgba(201,151,58,0.25)', borderRadius: 8, padding: '6px 14px', fontSize: 12, color: '#C9973A', cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 }}>Ask AI</button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 20 }}>
        {STATS.map(s => (
          <div key={s.label} style={{ background: 'white', border: '0.5px solid #e0e3e9', borderRadius: 12, padding: '14px 16px', borderTop: `3px solid ${s.color}` }}>
            <div style={{ fontSize: 10, color: '#999', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 6 }}>{s.label}</div>
            <div style={{ fontSize: 26, fontWeight: 500, lineHeight: 1 }}>{s.val}</div>
            <div style={{ fontSize: 11, color: '#999', marginTop: 5 }}>{s.sub}</div>
          </div>
        ))}
      </div>

      {/* Two columns */}
      <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 14, marginBottom: 20 }}>

        {/* Deadlines */}
        <div style={{ background: 'white', border: '0.5px solid #e0e3e9', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '11px 16px', background: '#f7f8fa', borderBottom: '0.5px solid #e0e3e9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 13, fontWeight: 500 }}>Upcoming deadlines</span>
            <a href="/deadlines" style={{ fontSize: 11, color: '#C9973A', textDecoration: 'none' }}>View all →</a>
          </div>
          {DEADLINES.map((d, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', borderBottom: i < DEADLINES.length - 1 ? '0.5px solid #e0e3e9' : 'none' }}>
              <div style={{ width: 3, alignSelf: 'stretch', minHeight: 36, borderRadius: 2, background: d.color, flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12, fontWeight: 500 }}>{d.name}</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 1 }}>{d.filing}</div>
              </div>
              <div style={{ fontSize: 12, fontWeight: 600, color: d.color }}>{d.days}d</div>
            </div>
          ))}
        </div>

        {/* Activity */}
        <div style={{ background: 'white', border: '0.5px solid #e0e3e9', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '11px 16px', background: '#f7f8fa', borderBottom: '0.5px solid #e0e3e9' }}>
            <span style={{ fontSize: 13, fontWeight: 500 }}>Recent activity</span>
          </div>
          {[
            ['Bank statement processed — 267 transactions, supported living client', 'Today', '#3B6D11'],
            ['6 WhatsApp reminders drafted and queued for approval', 'Today', '#C9973A'],
            ['CT600 draft — JO Tech Solutions Ltd, taxable profit £11,728', 'Yesterday', '#3B6D11'],
            ['Deadline alert: FW Catering Ltd — Conf. Statement due in 9 days', 'Yesterday', '#E24B4A'],
            ['SA100 completed — Emeka Osei, balance to pay £2,187', '2 days ago', '#3B6D11'],
          ].map(([text, time, color], i, arr) => (
            <div key={i} style={{ display: 'flex', gap: 10, padding: '9px 16px', borderBottom: i < arr.length - 1 ? '0.5px solid #e0e3e9' : 'none' }}>
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0, marginTop: 4 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12, lineHeight: 1.4 }}>{text}</div>
                <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>{time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modules grid */}
      <div style={{ background: 'white', border: '0.5px solid #e0e3e9', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ padding: '11px 16px', background: '#f7f8fa', borderBottom: '0.5px solid #e0e3e9' }}>
          <span style={{ fontSize: 13, fontWeight: 500 }}>All 11 modules</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, padding: 14 }}>
          {MODULES.map((m, i) => (
            <a key={i} href={m.path} style={{ textDecoration: 'none', background: '#f7f8fa', border: '0.5px solid #e0e3e9', borderRadius: 10, padding: 12, display: 'block', transition: 'border-color .15s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = '#C9973A'}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#e0e3e9'}>
              <div style={{ fontSize: 20, marginBottom: 7 }}>{m.icon}</div>
              <div style={{ fontSize: 12, fontWeight: 500, color: '#1a1a2e', marginBottom: 3 }}>{m.label}</div>
              <div style={{ fontSize: 11, color: '#888', lineHeight: 1.4, marginBottom: 6 }}>{m.desc}</div>
              <div style={{ fontSize: 10, color: m.live ? '#3B6D11' : '#bbb' }}>{m.live ? '✅ Live' : '🔜 Coming soon'}</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
